"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rebalancePrints = exports.getPatternLimit = exports.getProductTypeForSize = exports.sortFirstTag = exports.isWipesProduct = exports.multisizeVariantOption1 = exports.overflowDivId = exports.BundlerStep = exports.AppContext = void 0;
var storefront_client_1 = require("@rechargeapps/storefront-client");
var Cookies = __importStar(require("js-cookie"));
var partition_1 = __importDefault(require("lodash/partition"));
var times_1 = __importDefault(require("lodash/times"));
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var existing_customer_new_bundle_1 = require("../../misc/existing-customer-new-bundle");
var recharge_bundles_1 = require("../../misc/recharge-bundles");
var recharge_storefront_1 = require("../../misc/recharge-storefront");
var store_credit_1 = require("../../misc/store-credit");
var google_optimize_1 = require("../../utils/google-optimize");
var existing_customer_new_bundle_modal_1 = __importDefault(require("../essentials-bundler/components/existing-customer-new-bundle-modal"));
var allocate_add_ons_1 = __importDefault(require("./allocate-add-ons"));
var allocate_choices_1 = __importDefault(require("./allocate-choices"));
var calculate_price_1 = __importDefault(require("./calculate-price"));
var email_before_freebie_1 = require("./components/email-before-freebie");
var existing_active_bundle_modal_1 = __importDefault(require("./components/existing-active-bundle-modal"));
var left_1 = __importDefault(require("./components/left"));
var progress_1 = __importDefault(require("./components/progress"));
var scoll_on_nav_change_1 = __importDefault(require("./components/scoll-on-nav-change"));
var fetch_products_1 = __importDefault(require("./fetch-products"));
var group_variants_for_cart_add_1 = __importDefault(require("./group-variants-for-cart-add"));
var is_variant_available_1 = __importStar(require("./is-variant-available"));
var confirm_1 = __importDefault(require("./pages/confirm"));
var select_add_ons_1 = __importDefault(require("./pages/select-add-ons"));
var select_discount_add_ons_1 = __importDefault(require("./pages/select-discount-add-ons"));
var select_frequency_1 = __importDefault(require("./pages/select-frequency"));
var select_prints_1 = __importDefault(require("./pages/select-prints"));
var select_size_1 = __importDefault(require("./pages/select-size"));
var update_variants_with_future_quantities_1 = __importDefault(require("./update-variants-with-future-quantities"));
var validate_step_1 = __importDefault(require("./validate-step"));
var createContext = React.createContext, useEffect = React.useEffect, useMemo = React.useMemo, useState = React.useState;
var max = Math.max;
exports.AppContext = createContext(null);
var BundlerStep;
(function (BundlerStep) {
    BundlerStep["SELECT_SIZE"] = "select-size";
    BundlerStep["SELECT_PRINTS"] = "select-prints";
    BundlerStep["SELECT_ADD_ONS"] = "select-add-ons";
    BundlerStep["SELECT_DISCOUNT_ADD_ONS"] = "select-discount-add-ons";
    BundlerStep["SELECT_FREQUENCY"] = "select-frequency";
    BundlerStep["CONFIRM"] = "confirm";
})(BundlerStep = exports.BundlerStep || (exports.BundlerStep = {}));
var baseRoutes = [
    "/".concat(BundlerStep.SELECT_SIZE),
    "/".concat(BundlerStep.SELECT_PRINTS),
    "/".concat(BundlerStep.SELECT_ADD_ONS),
    "/".concat(BundlerStep.SELECT_DISCOUNT_ADD_ONS),
    "/".concat(BundlerStep.SELECT_FREQUENCY),
    "/".concat(BundlerStep.CONFIRM),
];
var allBundlerSteps = ['select-size', 'select-prints', 'select-add-ons', 'select-discount-add-ons', 'select-frequency', 'confirm'];
exports.overflowDivId = 'bundler-app-overflow-cell';
// if false, the first promotional freebie variant will be added to the cart if there is more than one variant for the item
// if true, a random promotional freebie variant will be added to the cart if there is more than one variant for the item
var shouldChooseRandomVariant = false;
// what value for option1 denotes that the variant is for a multiple-size bundle?
exports.multisizeVariantOption1 = 'Multi';
// simple helper function to determine if a product is a wipes product
var isWipesProduct = function (product) { return /wipes/i.test(product.title); };
exports.isWipesProduct = isWipesProduct;
exports.sortFirstTag = 'Bundler App Sort First';
// it is assumed that option2 of the bundle variants will start with the number of patterns allowed
// e.g., "7 packs + 4 wipes" or "20 packs"
var getAllocationLengthFromVariant = function (variant) {
    var defaultAllocationLength = 0;
    if (!variant) {
        return defaultAllocationLength;
    }
    var matches = variant.option2.match(/^(\d+)/);
    return matches ? Number(matches[1]) : defaultAllocationLength;
};
var getProductTypeForSize = function (size) {
    if (['12-24M', '2T-3T', '3T-4T', '4T-5T'].includes(size))
        return 'TrainingPants';
    return 'Diapers';
};
exports.getProductTypeForSize = getProductTypeForSize;
// hard-coded list of patterns limited to a certain number of selections per bundle (for both new and existing bundlers)
// e.g. limit 2 for Dr. Seuss diapers: const patternLimits: PatternLimit[] = [{ patternNames: ["Horton's Garden + Whoville Wrappers"], limitSizes: [3, 4], qtyLimit: 2 }]
var patternLimits = [];
var getPatternLimit = function (pattern) {
    return patternLimits.find(function (limit) { return limit.patternNames.includes(pattern.option2) && limit.limitSizes.includes(Number(pattern.option1)); });
};
exports.getPatternLimit = getPatternLimit;
var rebalancePrints = function (_a) {
    var existingChoices = _a.existingChoices, numNewChoices = _a.numNewChoices, eligibleNewChoices = _a.eligibleNewChoices;
    var newChoices = existingChoices.slice(0);
    for (var i = 0; i < numNewChoices; i++) {
        newChoices.push(eligibleNewChoices[i % eligibleNewChoices.length]);
    }
    return newChoices;
};
exports.rebalancePrints = rebalancePrints;
var App = function (_a) {
    var _b, _c;
    var customerCanChooseWipeslessSizes = _a.customerCanChooseWipeslessSizes, enableTrustPilotAB = _a.enableTrustPilotAB, enableNighttimeDiapers = _a.enableNighttimeDiapers, enableTrainingPants = _a.enableTrainingPants, existingBundle = _a.existingBundle, discountAddOnsPerLimit = _a.discountAddOnsPerLimit, futureQuantitiesDaysAhead = _a.futureQuantitiesDaysAhead, variantIdsMaxQty = _a.variantIdsMaxQty, hideLeft = _a.hideLeft, mainProduct = _a.mainProduct, mainTrainingPantsProduct = _a.mainTrainingPantsProduct, numAddOns = _a.numAddOns, numDiscountAddOns = _a.numDiscountAddOns, processFinalSubmit = _a.processFinalSubmit, promotionalAddOns = _a.promotionalAddOns, promotionalCodeAddOnMetafields = _a.promotionalCodeAddOnMetafields, skipSteps = _a.skipSteps, shippingIntervalFrequencies = _a.shippingIntervalFrequencies, shippingIntervalUnitType = _a.shippingIntervalUnitType, shouldHideLowStockItems = _a.shouldHideLowStockItems, steps = _a.steps, directStep = _a.directStep, preSelectedBundleType = _a.preSelectedBundleType, subscriptionId = _a.subscriptionId, bundlerSizesForExistingCustomersOnly = _a.bundlerSizesForExistingCustomersOnly, activeSubscriber = _a.activeSubscriber, newBundleConfirmationContent = _a.newBundleConfirmationContent, newBundleConfirmationEnabled = _a.newBundleConfirmationEnabled, rcBundlesForAcquisitionEnabled = _a.rcBundlesForAcquisitionEnabled, mainRcBundleProduct = _a.mainRcBundleProduct, props = __rest(_a, ["customerCanChooseWipeslessSizes", "enableTrustPilotAB", "enableNighttimeDiapers", "enableTrainingPants", "existingBundle", "discountAddOnsPerLimit", "futureQuantitiesDaysAhead", "variantIdsMaxQty", "hideLeft", "mainProduct", "mainTrainingPantsProduct", "numAddOns", "numDiscountAddOns", "processFinalSubmit", "promotionalAddOns", "promotionalCodeAddOnMetafields", "skipSteps", "shippingIntervalFrequencies", "shippingIntervalUnitType", "shouldHideLowStockItems", "steps", "directStep", "preSelectedBundleType", "subscriptionId", "bundlerSizesForExistingCustomersOnly", "activeSubscriber", "newBundleConfirmationContent", "newBundleConfirmationEnabled", "rcBundlesForAcquisitionEnabled", "mainRcBundleProduct"]);
    var _d = __read(useState(props.addOns), 2), addOns = _d[0], setAddOns = _d[1];
    var _e = __read(useState(props.autoAddOns), 2), autoAddOns = _e[0], setAutoAddOns = _e[1];
    var _f = __read(useState(props.discountAddOns), 2), discountAddOns = _f[0], setDiscountAddOns = _f[1];
    var _g = __read(useState(props.possibleChoices), 2), possibleChoices = _g[0], setPossibleChoices = _g[1];
    var _h = __read(useState(props.possibleNighttimeChoices), 2), possibleNighttimeChoices = _h[0], setPossibleNighttimeChoices = _h[1];
    // all new bundles must fetch the products via ajax
    // existing bundles will have data loaded via graphql
    useEffect(function () {
        if (!existingBundle) {
            (0, fetch_products_1.default)().then(function (products) {
                setAddOns(products.addOns);
                setAutoAddOns(products.autoAddOns);
                setDiscountAddOns(products.discountAddOns);
                setPossibleChoices(products.possibleChoices);
                setPossibleNighttimeChoices(products.possibleNighttimeChoices);
            });
        }
    }, []);
    // https://optimize.google.com/optimize/home/#/accounts/4701473005/containers/11360071/experiments/1001
    var superSleekReduxExperimentId = (_b = props.optimizeExperimentIds) === null || _b === void 0 ? void 0 : _b.superSleekRedux;
    var variantId = (0, google_optimize_1.useExperiment)(superSleekReduxExperimentId);
    // inform the UI that we are waiting for a decision from Optimize
    var _j = __read(useState(!!superSleekReduxExperimentId && !existingBundle), 2), loadingOptimizeVariant = _j[0], setLoadingOptimizeVariant = _j[1];
    var _k = __read(useState(false), 2), isTestingExpandedMobileLayout = _k[0], setIsTestingExpandedMobileLayout = _k[1];
    switch (variantId) {
        case '0':
            // "normal" variant
            if (loadingOptimizeVariant)
                setLoadingOptimizeVariant(false);
            break;
        case '1':
            // alternate variant (SUPER SLEEK)
            if (loadingOptimizeVariant)
                setLoadingOptimizeVariant(false);
            if (!isTestingExpandedMobileLayout)
                setIsTestingExpandedMobileLayout(true);
            break;
    }
    // can delete this code when the email before freebie test ends
    var emailBeforeFreebieOptimizeVariantId = (0, google_optimize_1.useExperiment)('9OgHMPLxQcSmUYsCyiMbDQ');
    var isEmailBeforeFreebieTest = useMemo(function () { return emailBeforeFreebieOptimizeVariantId === '1' || window.location.search.includes(email_before_freebie_1.emailBeforeFreebieUrlInclusion); }, [emailBeforeFreebieOptimizeVariantId, window.location.search]);
    var _l = __read(useState(''), 2), collectedEmail = _l[0], setCollectedEmail = _l[1];
    var _m = __read(useState(true), 2), showHeader = _m[0], setShowHeader = _m[1];
    var _o = __read(useState(), 2), headerElement = _o[0], setHeaderElement = _o[1];
    var _p = __read(useState(), 2), headerAdjustElement = _p[0], setHeaderAdjustElement = _p[1];
    var _q = __read(useState(), 2), bundlerAppContainerElement = _q[0], setBundlerAppContainerElement = _q[1];
    var _r = __read(useState(0), 2), scrollHeight = _r[0], setScrollHeight = _r[1];
    var getMobileLayoutElements = function () {
        var header = document.getElementById('header-mobile');
        var headerAdjust = document.getElementById('header-adjust-mobile');
        var bundlerAppContainer = document.getElementById('bundler-app-overflow-cell');
        return { header: header, headerAdjust: headerAdjust, bundlerAppContainer: bundlerAppContainer };
    };
    var handleExpandedMobileLayoutSetup = function () {
        var _a = getMobileLayoutElements(), header = _a.header, headerAdjust = _a.headerAdjust, bundlerAppContainer = _a.bundlerAppContainer;
        setHeaderElement(header);
        setHeaderAdjustElement(headerAdjust);
        setBundlerAppContainerElement(bundlerAppContainer);
        setScrollHeight((bundlerAppContainer === null || bundlerAppContainer === void 0 ? void 0 : bundlerAppContainer.scrollHeight) || 0);
    };
    var resetMobileHeaderAndLayout = function () {
        var _a = getMobileLayoutElements(), header = _a.header, headerAdjust = _a.headerAdjust;
        header === null || header === void 0 ? void 0 : header.classList.add('active');
        headerAdjust === null || headerAdjust === void 0 ? void 0 : headerAdjust.classList.add('header-adjust');
        if (headerAdjust)
            headerAdjust.style.display = 'block';
    };
    useEffect(function () {
        if (!showHeader) {
            headerElement === null || headerElement === void 0 ? void 0 : headerElement.classList.remove('active');
        }
        else {
            headerElement === null || headerElement === void 0 ? void 0 : headerElement.classList.add('active');
        }
    }, [showHeader]);
    var lastScroll = 0;
    var scrollUp = 'scroll-up';
    var scrollDown = 'scroll-down';
    useEffect(function () {
        handleExpandedMobileLayoutSetup();
    }, [isTestingExpandedMobileLayout]);
    useEffect(function () {
        if (!isTestingExpandedMobileLayout) {
            resetMobileHeaderAndLayout();
            return;
        }
        if (bundlerAppContainerElement) {
            // only allow for responsive header if the content is scrollable
            if (scrollHeight > bundlerAppContainerElement.clientHeight) {
                headerAdjustElement === null || headerAdjustElement === void 0 ? void 0 : headerAdjustElement.classList.remove('header-adjust');
                headerElement === null || headerElement === void 0 ? void 0 : headerElement.classList.remove('active');
                // set up the scroll event for the bundler content to create a responsive mobile header
                bundlerAppContainerElement.onscroll = function () {
                    var currentScroll = bundlerAppContainerElement.scrollTop;
                    if (currentScroll <= 0) {
                        document.body.classList.remove(scrollUp);
                        setShowHeader(false);
                        return;
                    }
                    if (currentScroll > lastScroll && !document.body.classList.contains(scrollDown)) {
                        // down
                        document.body.classList.remove(scrollUp);
                        document.body.classList.add(scrollDown);
                        setShowHeader(false);
                    }
                    else if (currentScroll < lastScroll && document.body.classList.contains(scrollDown)) {
                        // up
                        document.body.classList.remove(scrollDown);
                        document.body.classList.add(scrollUp);
                        setShowHeader(true);
                    }
                    lastScroll = currentScroll;
                };
            }
            else {
                resetMobileHeaderAndLayout();
            }
        }
    }, [isTestingExpandedMobileLayout, headerElement, setHeaderAdjustElement, bundlerAppContainerElement, scrollHeight]);
    var convertExistingBundleChildrenToVariantArray = function (group) {
        if (!existingBundle)
            return [];
        var children = existingBundle.children; // coddle typescript
        return children.reduce(function (choices, child) {
            var incoming = group.find(function (_a) {
                var _b = __read(_a, 2), _ = _b[0], id = _b[1].id;
                return id === child.shopify_variant_id;
            });
            if (incoming && (0, is_variant_available_1.default)(incoming[1]) && !(0, is_variant_available_1.isProductDisallowed)(incoming[0])) {
                for (var i = 0; i < child.quantity; ++i) {
                    choices.push(incoming[1]);
                }
            }
            return choices;
        }, []);
    };
    var location = (0, react_router_dom_1.useLocation)();
    // if a certain query param is present, we'll override the customerCanChooseWipeslessSizes prop
    // so that the rest of the bundler app thinks the customer wants a wipesless bundle
    // once the A/B test is done, we can delete this block of code
    var allowWipeslessSizesFromUrl = useMemo(function () { return window.location.search.includes('wpl=1'); }, []);
    if (allowWipeslessSizesFromUrl)
        customerCanChooseWipeslessSizes = true;
    var numChoicesPerSize = useMemo(function () {
        if (!possibleChoices)
            return;
        // first use Sets to uniquely build a list of patterns per size
        var setDict = possibleChoices.concat(possibleNighttimeChoices || []).reduce(function (obj, variant) {
            if (typeof obj[variant.option1] === 'undefined')
                obj[variant.option1] = new Set();
            if ((0, is_variant_available_1.default)(variant))
                obj[variant.option1].add(variant.option2);
            return obj;
        }, {});
        // then convert it to a lookup of Set.size
        return Object.keys(setDict).reduce(function (obj, key) {
            obj[key] = setDict[key].size;
            return obj;
        }, {});
    }, [possibleChoices]);
    var _s = __read(useState(function () {
        // preSelectedBundleType is for setting a default bundleType outside of url search params
        // e.g. setting in cancellation save flow to allow pre-select type for user
        if (preSelectedBundleType)
            return preSelectedBundleType;
        if (!existingBundle) {
            // if there is no existing bundle, we allow setting bundleType via URL, with default of Diapers
            var search = window.location.search;
            if (search.includes('bt=d'))
                return 'Diapers';
            if (search.includes('bt=tp'))
                return 'TrainingPants';
            if (search.includes('bt=m'))
                return 'Mixed';
            return 'Diapers';
        }
        // if there is an existing bundle and it's training pants only
        if (existingBundle.subscription.shopify_product_id === (mainTrainingPantsProduct === null || mainTrainingPantsProduct === void 0 ? void 0 : mainTrainingPantsProduct.id))
            return 'TrainingPants';
        // if it has at least 1 training pants child, it's a mixed bundle
        if (existingBundle.children.some(function (c) { var _a; return ((_a = c.variant) === null || _a === void 0 ? void 0 : _a.option1) && (0, exports.getProductTypeForSize)(c.variant.option1) === 'TrainingPants'; }))
            return 'Mixed';
        // otherwise it is diapers by default
        return 'Diapers';
    }), 2), selBundleType = _s[0], setSelBundleType = _s[1];
    var _t = __read(useState(null), 2), promotionalCookie = _t[0], setPromotionalCookie = _t[1];
    var _u = __read(useState([]), 2), filteredPromotionalAddOns = _u[0], setFilteredPromotionalAddOns = _u[1];
    var _v = __read(useState(function () { return (existingBundle ? convertExistingBundleChildrenToVariantArray(addOns || []) : []); }), 2), selAddOns = _v[0], setSelAddOns = _v[1];
    var _w = __read(useState(function () {
        if (!existingBundle) {
            // if there is no existing bundle and bundleType is mixed, chose the correct multisize variant based on the initial wipes setting
            if (selBundleType === 'Mixed')
                return mainProduct === null || mainProduct === void 0 ? void 0 : mainProduct.variants.find(function (v) {
                    return (v.option1 === exports.multisizeVariantOption1 && !customerCanChooseWipeslessSizes && v.option2.includes('wipes')) ||
                        (customerCanChooseWipeslessSizes && !v.option2.includes('wipes'));
                });
            else
                return;
        }
        var product = existingBundle.subscription.shopify_product_id === (mainTrainingPantsProduct === null || mainTrainingPantsProduct === void 0 ? void 0 : mainTrainingPantsProduct.id) ? mainTrainingPantsProduct : mainProduct;
        return product === null || product === void 0 ? void 0 : product.variants.find(function (_a) {
            var id = _a.id;
            return id === existingBundle.subscription.shopify_variant_id;
        });
    }), 2), selMainVariant = _w[0], setSelMainVariant = _w[1];
    var _x = __read(useState(false), 2), refresh = _x[0], setRefresh = _x[1];
    var _y = __read(useState(false), 2), isHandlingFinalSubmitClick = _y[0], setIsHandlingFinalSubmitClick = _y[1];
    var allocationLength = useMemo(function () { return getAllocationLengthFromVariant(selMainVariant); }, [selMainVariant]);
    var variantsWithLimitedQuantities = useMemo(function () {
        return (variantIdsMaxQty === null || variantIdsMaxQty === void 0 ? void 0 : variantIdsMaxQty.reduce(function (limitedVariants, variants) {
            var e_1, _a;
            try {
                for (var _b = __values(variants.variantIds), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var variantId_1 = _c.value;
                    limitedVariants.push(variantId_1);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return limitedVariants;
        }, [])) || [];
    }, [variantIdsMaxQty]);
    // determine initial choices and size quantities at the same time
    // be careful that OOS choices should NOT be considered in determining the sizeQuantities
    var _z = __read(useMemo(function () {
        if (!possibleChoices || !existingBundle || preSelectedBundleType) {
            return [[], []];
        }
        var allPossibleChoices = possibleChoices.concat(possibleNighttimeChoices || []);
        var children = existingBundle.children; // coddle typescript
        return children.reduce(function (_a, child) {
            var _b = __read(_a, 2), choices = _b[0], sizeQuantities = _b[1];
            var incoming = allPossibleChoices.find(function (_a) {
                var id = _a.id;
                return id === child.shopify_variant_id;
            });
            if (!incoming) {
                return [choices, sizeQuantities];
            } // this should never happen
            // allocating choices is easy
            var newChoices = (0, is_variant_available_1.default)(incoming) ? choices.concat((0, times_1.default)(child.quantity, function () { return incoming; })) : choices;
            // use the size of the incoming option to determine size quantities
            var existingSizeQuantity = sizeQuantities.find(function (_a) {
                var size = _a.size;
                return size === incoming.option1;
            });
            if (existingSizeQuantity) {
                existingSizeQuantity.quantity += child.quantity;
            }
            else {
                sizeQuantities.push({ size: incoming.option1, quantity: child.quantity, productType: (0, exports.getProductTypeForSize)(incoming.option1) });
            }
            return [newChoices, sizeQuantities];
        }, [[], []]);
    }, []), 2), initialSelChoices = _z[0], initialSelSizeQuantities = _z[1];
    var _0 = __read(useState(initialSelChoices), 2), selChoices = _0[0], setSelChoices = _0[1];
    var _1 = __read(useState(function () {
        return existingBundle ? convertExistingBundleChildrenToVariantArray(discountAddOns ? discountAddOns : []) : [];
    }), 2), selDiscountAddOns = _1[0], setSelDiscountAddOns = _1[1];
    var _2 = __read(useState(initialSelSizeQuantities), 2), selSizeQuantities = _2[0], setSelSizeQuantities = _2[1];
    var _3 = __read(useState(function () {
        if (existingBundle)
            return !(selMainVariant === null || selMainVariant === void 0 ? void 0 : selMainVariant.option2.includes('wipes'));
        return customerCanChooseWipeslessSizes;
    }), 2), shouldShowWipeslessSizes = _3[0], setShouldShowWipeslessSizes = _3[1];
    var _4 = __read(useState((function () {
        // existing customers don't change frequency in the bundler, so we'll leave it null
        if (existingBundle)
            return null;
        // otherwise default all new customers to 5 (or the value of the optimize test)
        return window.OPTIMIZE_FREQUENCY_WEEKS || 5;
    })()), 2), selShippingFrequency = _4[0], setSelShippingFrequency = _4[1];
    var totalSizeQuantitiesSum = useMemo(function () { return selSizeQuantities.reduce(function (sum, sq) { return sum + sq.quantity; }, 0); }, [selSizeQuantities]);
    var skipStepsMemoized = useMemo(function () {
        // if the window variable for showing the frequency selection step is set by optimize, allow user to select frequency other than default
        var filteredSteps = window.OPTIMIZE_SHOW_BUNDLER_FREQUENCY_STEP ? skipSteps === null || skipSteps === void 0 ? void 0 : skipSteps.filter(function (step) { return step !== 'select-frequency'; }) : skipSteps;
        // if the window variable for skipping discount add-ons is set by optimize, add selecting discount add-ons as a step that we should take out
        // @ts-ignore
        return window.OPTIMIZE_SKIP_ADD_ONS_STEP ? __spreadArray(__spreadArray([], __read(filteredSteps), false), ['select-discount-add-ons'], false) : filteredSteps;
    }, [skipSteps, window.OPTIMIZE_SHOW_BUNDLER_FREQUENCY_STEP, window.OPTIMIZE_SKIP_ADD_ONS_STEP]);
    var bundlerSteps = useMemo(function () { return allBundlerSteps.filter(function (step) { return !skipStepsMemoized || !skipStepsMemoized.includes(step); }); }, [skipStepsMemoized === null || skipStepsMemoized === void 0 ? void 0 : skipStepsMemoized.join()]);
    var bundlerSubSteps = useMemo(function () {
        return bundlerSteps.map(function (bundlerStep) {
            if (bundlerStep === 'select-prints') {
                return selSizeQuantities.map(function (sq) { return sq.size; });
            }
            return [];
        });
    }, [selSizeQuantities]);
    // Used to force rerender for A/B testing
    useEffect(function () {
        window.addEventListener('bundlerAppRerender', function () {
            setRefresh(!refresh);
        });
    }, []);
    // for new bundles, if there is a futureQuantitiesDaysAhead setting, load future quantities
    useEffect(function () {
        if (existingBundle || !futureQuantitiesDaysAhead || !possibleChoices)
            return;
        (0, update_variants_with_future_quantities_1.default)({
            daysAhead: Number(futureQuantitiesDaysAhead),
            possibleChoices: possibleChoices,
            possibleNighttimeChoices: possibleNighttimeChoices,
            addOns: addOns,
            discountAddOns: discountAddOns,
        });
    }, [possibleChoices]);
    // determine the current step based on the location
    var _5 = __read(useMemo(function () {
        var _a;
        var _b = __read(location.pathname.split('/'), 3), _ = _b[0], baseRoute = _b[1], subRoute = _b[2];
        var newIdx = max(bundlerSteps.indexOf(baseRoute), 0);
        return [newIdx, max((_a = bundlerSubSteps[newIdx]) === null || _a === void 0 ? void 0 : _a.indexOf(subRoute), 0)];
    }, [location]), 2), currentStepIdx = _5[0], currentSubStepIdx = _5[1];
    // show the multisize bundle switch for anyone who already has multiple sizes,
    // or for existing customers if the CMS setting is enabled,
    // or for new customers if the CMS setting is enabled
    var shouldShowMultisizeBundleSwitch = useMemo(function () { return selSizeQuantities.length > 1 || (existingBundle && steps[0].allowMultisizeBundlesExistingCustomers) || (!existingBundle && steps[0].allowMultisizeBundlesNewCustomers); }, []);
    // update the promotionalCookie and the filteredPromotionalAddOns if the promoCode cookie or the mainVariant size has changed
    var promoCodeCookieValue = Cookies.get('promoCode');
    useEffect(function () {
        setPromotionalCookie(promoCodeCookieValue);
        setFilteredPromotionalAddOns(promotionalAddOns
            ? promotionalAddOns.filter(function (product) {
                var metaFields = promotionalCodeAddOnMetafields ? promotionalCodeAddOnMetafields["".concat(product.handle)] : undefined;
                var promoCode = metaFields === null || metaFields === void 0 ? void 0 : metaFields.promoCode;
                // if the product doesn't have a promoCode set in the metafields, then don't add it
                if (!promoCode) {
                    return false;
                }
                // only add diaper packs for the correct size
                if (product.title.includes('Diaper Pack')) {
                    return selMainVariant && promoCode === promotionalCookie && product.title.includes('Size ' + selMainVariant.title[0]);
                }
                // TODO: not sure how this works; we just ran setPromotionalCookie during this same render, so we won't have the new value yet
                // make sure to only add the product if the promoCode matched the promotionalCookie set from the url param
                return promoCode === promotionalCookie;
            })
            : []);
    }, [promotionalCookie, promoCodeCookieValue, selMainVariant]);
    var notifyDataLayer = function (bundleVariant) {
        var _a;
        (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ event: 'diaperBundle__addToCart', bundleVariantId: bundleVariant.id, bundleVariantName: bundleVariant.name });
    };
    var handleFinalSubmitClick = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var mainBundleProductId, activeSizeQuantity, activeSelChoices, patternsEligibleForBalance, finalChoices, bundleId, addOnOrigTotals, discountAddOnOrigTotals, frequency, subscriptionProperties, childProperties, autoAddOnVariants, promotionalAddOnVariants, bundleChoices, onetimeItems, promotionalAddonItems, choices, choices, bundleItemParams_1, shopifyVariantId, redirectToCheckout, params, cdnBundleSettings, choices, onetimeItems_1, onetimeItems_1_1, onetimeItem, promotionalAddonItems_1, promotionalAddonItems_1_1, promotionalAddonItem, succeededAddingItemToCart;
        var e_2, _a, e_3, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    mainBundleProductId = (mainProduct === null || mainProduct === void 0 ? void 0 : mainProduct.id) || (existingBundle === null || existingBundle === void 0 ? void 0 : existingBundle.subscription.shopify_product_id);
                    if (!mainBundleProductId) {
                        if (rcBundlesForAcquisitionEnabled) {
                            throw new Error('Recharge bundles are enabled, but cannot determine mainBundleProductId');
                        }
                        else {
                            // we don't access this value during the hellobello bundles flow, so we just fake it to make typescript happy until we can fully
                            // migrate to recharge bundles and remove the hellobello bundles code
                            mainBundleProductId = 0;
                        }
                    }
                    // make sure customers can only do 1 final submit action at a time
                    if (isHandlingFinalSubmitClick)
                        return [2 /*return*/];
                    setIsHandlingFinalSubmitClick(true);
                    if (!selMainVariant || selChoices.length === 0) {
                        return [2 /*return*/];
                    }
                    activeSizeQuantity = selSizeQuantities[currentSubStepIdx];
                    activeSelChoices = selChoices.filter(function (v) { return v.option1 === activeSizeQuantity.size; });
                    patternsEligibleForBalance = activeSelChoices.filter(function (choice) { return !(0, exports.getPatternLimit)(choice); });
                    finalChoices = existingBundle
                        ? (0, exports.rebalancePrints)({
                            existingChoices: selChoices,
                            numNewChoices: activeSizeQuantity.quantity - activeSelChoices.length,
                            eligibleNewChoices: patternsEligibleForBalance,
                        })
                        : selChoices;
                    bundleId = (function () {
                        if (!existingBundle || existingBundle.manager === 'recharge') {
                            return new Date().getTime().toString();
                        }
                        else {
                            var prop = existingBundle.subscription.properties.find(function (_a) {
                                var name = _a.name;
                                return name === 'bundle_id';
                            });
                            if (!prop)
                                throw new Error('unable to find bundle id for hellobello bundle');
                            return prop.value;
                        }
                    })();
                    addOnOrigTotals = selAddOns.map(function (addOn) { return Number(addOn.compare_at_price); }).reduce(function (acc, prc) { return acc + prc; }, 0);
                    discountAddOnOrigTotals = selDiscountAddOns.map(function (addOn) { return Number(addOn.compare_at_price); }).reduce(function (acc, prc) { return acc + prc; }, 0);
                    frequency = (selShippingFrequency || '').toString();
                    subscriptionProperties = (function () {
                        var properties = {};
                        if (!existingBundle) {
                            // we include these properties even on recharge bundles because they are used by our cart, not by recharge
                            properties.original_bundle_value = addOnOrigTotals + discountAddOnOrigTotals + Number(selMainVariant.price) / 100;
                            properties.compare_at_price = Number(selMainVariant.compare_at_price || selMainVariant.price);
                        }
                        if (!existingBundle && !rcBundlesForAcquisitionEnabled) {
                            // we don't need to add these props to existing bundles or when using recharge bundles
                            properties.charge_interval_frequency = frequency;
                            properties.shipping_interval_frequency = frequency;
                            properties.shipping_interval_unit_type = shippingIntervalUnitType;
                            properties.subscription_id = subscriptionId;
                        }
                        return properties;
                    })();
                    childProperties = __assign({ parent_bundle_id: bundleId }, subscriptionProperties);
                    autoAddOnVariants = (function () {
                        if (!autoAddOns) {
                            return [];
                        }
                        return autoAddOns.reduce(function (arr, _a, i) {
                            var _b = __read(_a, 2), _ = _b[0], variant = _b[1];
                            for (var j = 0; j < getAutoAddOnQty(variant); j++) {
                                arr.push(variant);
                            }
                            return arr;
                        }, []);
                    })();
                    promotionalAddOnVariants = (function () {
                        return filteredPromotionalAddOns.reduce(function (arr, product) {
                            var availableVariants = product.variants.filter(function (variant) { return (0, is_variant_available_1.default)(variant); });
                            if (product.variants.length >= 1) {
                                arr.push(availableVariants[shouldChooseRandomVariant ? Math.floor(Math.random() * product.variants.length) : 0]);
                            }
                            return arr;
                        }, []);
                    })();
                    bundleChoices = __spreadArray(__spreadArray(__spreadArray([
                        // first we include the main bundle product
                        {
                            createItemParams: [selMainVariant.id, { properties: __assign({ bundle_id: bundleId }, subscriptionProperties) }],
                            variant: __assign(__assign({}, selMainVariant), { product: { id: mainBundleProductId } }),
                        }
                    ], __read((0, group_variants_for_cart_add_1.default)(finalChoices.map(function (choice) { return (__assign(__assign({}, choice), { product: { id: choice.product_id } })); }), childProperties)), false), __read((0, group_variants_for_cart_add_1.default)(selDiscountAddOns.map(function (choice) { return (__assign(__assign({}, choice), { product: { id: choice.product_id } })); }), childProperties)), false), __read((0, group_variants_for_cart_add_1.default)(autoAddOnVariants.map(function (choice) { return (__assign(__assign({}, choice), { product: { id: choice.product_id } })); }), childProperties)), false);
                    onetimeItems = (0, group_variants_for_cart_add_1.default)(selAddOns.map(function (choice) { return (__assign(__assign({}, choice), { product: { id: choice.product_id } })); }), { parent_bundle_id: bundleId });
                    promotionalAddonItems = (0, group_variants_for_cart_add_1.default)(promotionalAddOnVariants.map(function (choice) { return (__assign(__assign({}, choice), { product: { id: choice.product_id } })); }), { parent_bundle_id: bundleId });
                    // if there is a promoCode cookie present remove it since we're done with it now
                    Cookies.remove('promoCode');
                    if (!processFinalSubmit) return [3 /*break*/, 2];
                    choices = __spreadArray(__spreadArray(__spreadArray([], __read(bundleChoices), false), __read(onetimeItems), false), __read(promotionalAddonItems), false);
                    return [4 /*yield*/, processFinalSubmit(choices.map(function (item) { return item.createItemParams; }))];
                case 1:
                    _c.sent();
                    return [3 /*break*/, 12];
                case 2:
                    if (!existingCustomerNewBundleParams) return [3 /*break*/, 7];
                    choices = __spreadArray([], __read(bundleChoices), false);
                    bundleItemParams_1 = choices.map(function (item) { return item.createItemParams; });
                    shopifyVariantId = (function () {
                        if (rcBundlesForAcquisitionEnabled) {
                            if (!mainRcBundleProduct)
                                throw new Error('Recharge bundles enabled but mainRcBundleProduct is missing');
                            return mainRcBundleProduct.variants[0].id; // we expect there to only be one variant, and it's the one we want
                        }
                        return bundleItemParams_1[0][0]; // main bundle product variant id
                    })();
                    _c.label = 3;
                case 3:
                    _c.trys.push([3, , 5, 6]);
                    return [4 /*yield*/, createNewBundleForExistingCustomer(__assign(__assign({}, existingCustomerNewBundleParams), { shopifyVariantId: shopifyVariantId, shippingIntervalUnitType: shippingIntervalUnitType, frequency: Number(frequency), bundleId: bundleId, bundleItemParams: bundleItemParams_1, onetimeParams: onetimeItems.map(function (item) { return item.createItemParams; }) }))];
                case 4:
                    _c.sent();
                    return [3 /*break*/, 6];
                case 5:
                    setIsHandlingFinalSubmitClick(false);
                    return [7 /*endfinally*/];
                case 6: return [3 /*break*/, 12];
                case 7:
                    redirectToCheckout = typeof window.OPTIMIZE_REDIRECT_BUNDLER_TO_CHECKOUT !== undefined ? window.OPTIMIZE_REDIRECT_BUNDLER_TO_CHECKOUT : false;
                    notifyDataLayer(selMainVariant);
                    params = void 0;
                    if (!rcBundlesForAcquisitionEnabled) return [3 /*break*/, 9];
                    if (!mainRcBundleProduct)
                        throw new Error('Recharge bundles enabled but mainRcBundleProduct is missing');
                    return [4 /*yield*/, (0, storefront_client_1.getCDNBundleSettings)(mainRcBundleProduct.id)];
                case 8:
                    cdnBundleSettings = _c.sent();
                    if (!cdnBundleSettings)
                        throw new Error("Failed to fetch bundle settings for product id ".concat(mainRcBundleProduct.id));
                    params = (0, recharge_bundles_1.buildDynamicRechargeBundle)({
                        choices: bundleChoices,
                        cdnBundleSettings: cdnBundleSettings,
                        mainRcBundleProduct: mainRcBundleProduct,
                        shippingIntervalFrequency: Number(frequency),
                        shippingIntervalUnitType: shippingIntervalUnitType,
                    });
                    return [3 /*break*/, 10];
                case 9:
                    choices = __spreadArray([], __read(bundleChoices), false);
                    params = choices.map(function (item) { return item.createItemParams; });
                    _c.label = 10;
                case 10:
                    try {
                        // Add non-subscription items after calling buildDynamicRechargeBundle so that they don't end up in the bundle_selection that recharge will create.
                        // If this happened, these items would be included in the BundleSelection and so the customer would be subscribed to them.
                        for (onetimeItems_1 = __values(onetimeItems), onetimeItems_1_1 = onetimeItems_1.next(); !onetimeItems_1_1.done; onetimeItems_1_1 = onetimeItems_1.next()) {
                            onetimeItem = onetimeItems_1_1.value;
                            params.push(onetimeItem.createItemParams);
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (onetimeItems_1_1 && !onetimeItems_1_1.done && (_a = onetimeItems_1.return)) _a.call(onetimeItems_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    try {
                        for (promotionalAddonItems_1 = __values(promotionalAddonItems), promotionalAddonItems_1_1 = promotionalAddonItems_1.next(); !promotionalAddonItems_1_1.done; promotionalAddonItems_1_1 = promotionalAddonItems_1.next()) {
                            promotionalAddonItem = promotionalAddonItems_1_1.value;
                            params.push(promotionalAddonItem.createItemParams);
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (promotionalAddonItems_1_1 && !promotionalAddonItems_1_1.done && (_b = promotionalAddonItems_1.return)) _b.call(promotionalAddonItems_1);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                    return [4 /*yield*/, window.cartApp.add(params, { redirectToCheckout: redirectToCheckout })
                        // When redirecting to checkout, we want to keep the state such that we are "loading" forever, as far as the bundler app is concerned. The browser will
                        // eventually redirect to the checkout page and the state of the bundler app won't matter. So we don't change that state to "not loading" unless there
                        // was an error that will prevent the browser from redirecting. This is a workaround for the fact that browsers continue JS execution after being
                        // instructed to redirect, and without this workaround, we'll turn off our loading UI stuff before the user is redirected.
                    ];
                case 11:
                    succeededAddingItemToCart = _c.sent();
                    // When redirecting to checkout, we want to keep the state such that we are "loading" forever, as far as the bundler app is concerned. The browser will
                    // eventually redirect to the checkout page and the state of the bundler app won't matter. So we don't change that state to "not loading" unless there
                    // was an error that will prevent the browser from redirecting. This is a workaround for the fact that browsers continue JS execution after being
                    // instructed to redirect, and without this workaround, we'll turn off our loading UI stuff before the user is redirected.
                    if (!redirectToCheckout)
                        setIsHandlingFinalSubmitClick(false);
                    if (redirectToCheckout && !succeededAddingItemToCart)
                        setIsHandlingFinalSubmitClick(false);
                    _c.label = 12;
                case 12: return [2 /*return*/];
            }
        });
    }); };
    var handleChangeMainVariantClick = function (variant) { return function () {
        setSelChoices([]);
        setSelMainVariant(variant);
        setSelSizeQuantities(variant && variant.option1 !== exports.multisizeVariantOption1
            ? [{ size: variant.option1, quantity: getAllocationLengthFromVariant(variant), productType: (0, exports.getProductTypeForSize)(variant.option1) }]
            : []);
    }; };
    var handleChangeShippingFrequencyClick = function (newShippingFrequency) { return function () {
        setSelShippingFrequency(newShippingFrequency);
    }; };
    var handleIncreaseAddOnClick = function (incoming) { return function () {
        // never allow selection of unavailable variants
        if (!(0, is_variant_available_1.default)(incoming))
            return;
        if (numAddOns === 1) {
            if (selAddOns.some(function (variant) { return variant.id === incoming.id; })) {
                return setSelAddOns([]);
            }
            return setSelAddOns([incoming]);
        }
        if (selAddOns.length + 1 <= numAddOns) {
            return setSelAddOns(selAddOns.concat(incoming));
        }
    }; };
    var handleIncreaseDiscountAddOnClick = function (incoming) { return function () {
        // never allow selection of unavailable variants
        if (!(0, is_variant_available_1.default)(incoming))
            return;
        // if trying to add a "limited" variant id, make sure we don't add more than the allowed amount for it
        if (variantsWithLimitedQuantities.includes(incoming.id)) {
            var limitedQtyVariantsMap_1 = variantIdsMaxQty === null || variantIdsMaxQty === void 0 ? void 0 : variantIdsMaxQty.filter(function (variantMapping) { return variantMapping.variantIds.includes(incoming.id); });
            if (limitedQtyVariantsMap_1 && selDiscountAddOns.filter(function (v) { return limitedQtyVariantsMap_1[0].variantIds.includes(v.id); }).length >= limitedQtyVariantsMap_1[0].maxQty) {
                return;
            }
        }
        else if (discountAddOnsPerLimit && selDiscountAddOns.filter(function (v) { return v.id === incoming.id; }).length >= discountAddOnsPerLimit) {
            // if there is a limit set, make sure it is respected
            return;
        }
        // if there is room for the new add-on, add it
        if (selDiscountAddOns.length + 1 <= numDiscountAddOns) {
            return setSelDiscountAddOns(selDiscountAddOns.concat(incoming));
        }
    }; };
    var handleDecreaseAddOnClick = function (incoming) { return function () {
        var didRemove = false;
        setSelAddOns(selAddOns.filter(function (variant) {
            if (variant.id === incoming.id && !didRemove) {
                didRemove = true;
                return false;
            }
            else {
                return true;
            }
        }));
    }; };
    var handleDecreaseDiscountAddOnClick = function (incoming) { return function () {
        var didRemove = false;
        setSelDiscountAddOns(selDiscountAddOns.filter(function (variant) {
            if (variant.id === incoming.id && !didRemove) {
                didRemove = true;
                return false;
            }
            else {
                return true;
            }
        }));
    }; };
    var handleToggleAddOnClick = function (incoming) { return function () {
        var newSelAddOns = (0, allocate_add_ons_1.default)({ addOns: selAddOns, incoming: incoming, length: numAddOns });
        setSelAddOns(newSelAddOns);
    }; };
    var handleToggleDiscountAddOnClick = function (incoming) { return function () {
        var newSelDiscountAddOns = (0, allocate_add_ons_1.default)({ addOns: selDiscountAddOns, incoming: incoming, length: numDiscountAddOns });
        setSelDiscountAddOns(newSelDiscountAddOns);
    }; };
    var handleToggleChoiceClick = function (incoming) { return function () {
        var activeSizeQuantity = selSizeQuantities.find(function (_a) {
            var size = _a.size;
            return size === incoming.option1;
        });
        if (!activeSizeQuantity)
            return;
        // we only want to allocate the selected sizeQuantity, and keep everything else that has already been selected
        var _a = __read((0, partition_1.default)(selChoices, function (c) { return c.option1 === incoming.option1; }), 2), sameSizeSelChoices = _a[0], otherSizeSelChoices = _a[1];
        var newSelChoices = (0, allocate_choices_1.default)({ incoming: incoming, choices: sameSizeSelChoices, length: activeSizeQuantity.quantity });
        setSelChoices(newSelChoices.concat(otherSizeSelChoices));
    }; };
    var handleAddPattern = function (incoming) { return function () {
        // check to see if the incoming pattern has a pattern limit setting
        var patternLimit = (0, exports.getPatternLimit)(incoming);
        if (patternLimit) {
            var patternNames_1 = patternLimit.patternNames, qtyLimit = patternLimit.qtyLimit;
            // tally of all selected patterns for the group
            var numSelected = selChoices.reduce(function (acc, pattern) { return (patternNames_1.includes(pattern.option2) ? acc + 1 : acc); }, 0);
            // if adding the incoming pattern puts us over the limit quantity for the pattern, don't add it
            if (numSelected >= qtyLimit) {
                return;
            }
        }
        var activeSizeQuantity = selSizeQuantities.find(function (_a) {
            var size = _a.size;
            return size === incoming.option1;
        });
        if (!activeSizeQuantity) {
            return;
        } // shouldn't ever encounter this
        var activeSelChoices = selChoices.filter(function (v) { return v.option1 === activeSizeQuantity.size; });
        var newSelChoices = activeSelChoices.length >= activeSizeQuantity.quantity ? selChoices : selChoices.concat(incoming);
        setSelChoices(newSelChoices);
    }; };
    var handleSubPattern = function (incoming) { return function () {
        if (selChoices.length === 0) {
            return;
        }
        var didRemove = false;
        setSelChoices(selChoices.filter(function (variant) {
            if (variant.id === incoming.id && !didRemove) {
                didRemove = true;
                return false;
            }
            else {
                return true;
            }
        }));
    }; };
    var handleToggleWipeslessSizesClick = function () {
        // if a size is already selected, select the same size with the opposite wipes option
        var newSelMainVariant = selMainVariant
            ? mainProduct === null || mainProduct === void 0 ? void 0 : mainProduct.variants.find(function (v) {
                return v.option1 === selMainVariant.option1 &&
                    v.option2 !== selMainVariant.option2 &&
                    (v.option2.includes(selMainVariant.option2) || selMainVariant.option2.includes(v.option2));
            })
            : undefined;
        setSelMainVariant(newSelMainVariant);
        setShouldShowWipeslessSizes(!shouldShowWipeslessSizes);
    };
    var handleIncreaseSizeQuantityClick = function (size) { return function () {
        // don't do anything if we've already reached the max
        if (totalSizeQuantitiesSum >= allocationLength)
            return;
        var newSizeQuantities = selSizeQuantities.slice(0);
        var existingIdx = newSizeQuantities.findIndex(function (sq) { return sq.size === size; });
        if (existingIdx !== -1) {
            newSizeQuantities[existingIdx].quantity++;
        }
        else if (selSizeQuantities.length < parseInt(steps[0].numMultisizesAllowed || 1, 10)) {
            // don't do anything if we can't add more sizes
            newSizeQuantities.push({ size: size, quantity: 1, productType: (0, exports.getProductTypeForSize)(size) });
        }
        setSelSizeQuantities(newSizeQuantities);
    }; };
    var handleDecreaseSizeQuantityClick = function (size) { return function () {
        var newSelSizeQuantities = selSizeQuantities.reduce(function (arr, sq) {
            if (sq.size === size) {
                if (sq.quantity > 1) {
                    return arr.concat(__assign(__assign({}, sq), { quantity: sq.quantity - 1 }));
                }
                return arr;
            }
            return arr.concat(sq);
        }, []);
        // remove only 1 choice if needed
        var didRemoveChoice = false;
        var newSelChoices = selChoices.reduce(function (arr, choice) {
            if (!didRemoveChoice && choice.option1 === size) {
                didRemoveChoice = true;
                return arr;
            }
            return arr.concat(choice);
        }, []);
        setSelSizeQuantities(newSelSizeQuantities);
        if (didRemoveChoice) {
            setSelChoices(newSelChoices);
        }
    }; };
    var price = useMemo(function () { return (0, calculate_price_1.default)({ selAddOns: selAddOns, selDiscountAddOns: selDiscountAddOns, selMainVariant: selMainVariant, selChoices: selChoices }); }, [selAddOns, selDiscountAddOns, selMainVariant, selChoices]);
    var priceWithPromotionalProducts = useMemo(function () {
        return (0, calculate_price_1.default)({ selAddOns: selAddOns, selDiscountAddOns: selDiscountAddOns, selMainVariant: selMainVariant, selChoices: selChoices, promotionalAddOns: filteredPromotionalAddOns });
    }, [selAddOns, selDiscountAddOns, selMainVariant, filteredPromotionalAddOns, selChoices]);
    // TODO: use computeAutoAddonQty of ./auto-addon-qty.ts
    // figure out the quantity of the auto add-on variant depending on the selMainVariant
    var getAutoAddOnQty = function (variant) {
        // for wipes, we assume the number exists in option2 of the main variant
        // e.g., "7 packs + 4 wipes" = 4, "20 packs + 9 wipes" = 9, "7 packs" = 0
        if (variant.name.includes('Wipes') && selMainVariant) {
            var wipesMatches = selMainVariant.option2.match(/(\d+) Wipes/i);
            return wipesMatches ? Number(wipesMatches[1]) : 0;
        }
        // by default, autoAddOns will be quantity 1
        return 1;
    };
    // set up existing customer new bundle variables
    var _6 = (0, existing_customer_new_bundle_1.useCreateNewBundle)('Diaper'), createNewBundleForExistingCustomer = _6.finalSubmit, createNewBundleForExistingCustomerError = _6.error, isCreatingNewBundleForExistingCustomer = _6.isCreatingNewBundleForExistingCustomer, didExistingCustomerCreateNewBundle = _6.didExistingCustomerCreateNewBundle, existingCustomerNewBundleParams = _6.queryParams, getExistingCustomerNewBundleSavingsAndDiscount = _6.getSavingsAndDiscount, urlHasExistingCustomerNewBundleFlowQueryParams = _6.urlHasExistingCustomerNewBundleFlowQueryParams;
    // recalculate the existing-customer-new-bundle-savings when the price changes
    var _7 = useMemo(function () { return getExistingCustomerNewBundleSavingsAndDiscount(Number(price) * 100); }, // needs to be in cents
    [price]), existingCustomerNewBundleSavings = _7.savings, existingCustomerNewBundleDiscount = _7.discount;
    // prefetch this query for later use on the review screen
    var isLoggedIn = !!((_c = window.customer) === null || _c === void 0 ? void 0 : _c.id);
    (0, store_credit_1.useCustomerCreditAccount)({ enabled: !!isLoggedIn });
    // Initialize the recharge storefront sdk - we don't actually need a session, so we don't wait for it
    var result = (0, recharge_storefront_1.useInitRechargeStorefrontSdk)();
    if (!result.initialized)
        return null;
    var contextValue = {
        allBundlerSteps: allBundlerSteps,
        allocationLength: allocationLength,
        bundlerSteps: bundlerSteps,
        bundlerSubSteps: bundlerSubSteps,
        currentStepIdx: currentStepIdx,
        currentSubStepIdx: currentSubStepIdx,
        customerCanChooseWipeslessSizes: customerCanChooseWipeslessSizes,
        discountAddOnsPerLimit: discountAddOnsPerLimit,
        existingBundle: existingBundle,
        existingCustomerNewBundleParams: existingCustomerNewBundleParams,
        getAutoAddOnQty: getAutoAddOnQty,
        handleChangeMainVariantClick: handleChangeMainVariantClick,
        handleChangeShippingFrequencyClick: handleChangeShippingFrequencyClick,
        handleDecreaseAddOnClick: handleDecreaseAddOnClick,
        handleDecreaseDiscountAddOnClick: handleDecreaseDiscountAddOnClick,
        handleDecreaseSizeQuantityClick: handleDecreaseSizeQuantityClick,
        handleFinalSubmitClick: handleFinalSubmitClick,
        handleIncreaseAddOnClick: handleIncreaseAddOnClick,
        handleIncreaseDiscountAddOnClick: handleIncreaseDiscountAddOnClick,
        handleIncreaseSizeQuantityClick: handleIncreaseSizeQuantityClick,
        handleToggleAddOnClick: handleToggleAddOnClick,
        handleToggleChoiceClick: handleToggleChoiceClick,
        handleAddPattern: handleAddPattern,
        handleSubPattern: handleSubPattern,
        handleToggleDiscountAddOnClick: handleToggleDiscountAddOnClick,
        handleToggleWipeslessSizesClick: handleToggleWipeslessSizesClick,
        isEditingExistingBundle: !!existingBundle,
        isHandlingFinalSubmitClick: isHandlingFinalSubmitClick,
        isTestingExpandedMobileLayout: isTestingExpandedMobileLayout,
        handleExpandedMobileLayoutSetup: handleExpandedMobileLayoutSetup,
        mainProduct: mainProduct,
        mainTrainingPantsProduct: mainTrainingPantsProduct,
        price: price,
        priceWithPromotionalProducts: priceWithPromotionalProducts,
        promotionalCookie: promotionalCookie,
        filteredPromotionalAddOns: filteredPromotionalAddOns,
        selAddOns: selAddOns,
        selBundleType: selBundleType,
        setSelBundleType: setSelBundleType,
        selChoices: selChoices,
        selDiscountAddOns: selDiscountAddOns,
        setSelChoices: setSelChoices,
        setSelSizeQuantities: setSelSizeQuantities,
        selSizeQuantities: selSizeQuantities,
        selMainVariant: selMainVariant,
        selShippingFrequency: selShippingFrequency,
        shouldHideLowStockItems: shouldHideLowStockItems,
        shouldShowMultisizeBundleSwitch: shouldShowMultisizeBundleSwitch,
        shouldShowWipeslessSizes: shouldShowWipeslessSizes,
        skipSteps: skipStepsMemoized,
        totalSizeQuantitiesSum: totalSizeQuantitiesSum,
        bundlerSizesForExistingCustomersOnly: bundlerSizesForExistingCustomersOnly,
        variantIdsMaxQty: variantIdsMaxQty,
        refresh: refresh,
        existingCustomerNewBundleSavings: existingCustomerNewBundleSavings,
        existingCustomerNewBundleDiscount: existingCustomerNewBundleDiscount,
        collectedEmail: collectedEmail,
        setCollectedEmail: setCollectedEmail,
        isEmailBeforeFreebieTest: isEmailBeforeFreebieTest,
    };
    return (React.createElement(exports.AppContext.Provider, { value: contextValue },
        React.createElement(existing_customer_new_bundle_modal_1.default, { isOpen: didExistingCustomerCreateNewBundle }),
        /* don't show the modal if customers are trying to add a bundle */ !urlHasExistingCustomerNewBundleFlowQueryParams && (React.createElement(existing_active_bundle_modal_1.default, { existingBundle: !!existingBundle, activeSubscriber: !!activeSubscriber, newBundleConfirmationContent: newBundleConfirmationContent, newBundleConfirmationEnabled: newBundleConfirmationEnabled })),
        React.createElement("div", { className: 'grid-x width-100', style: { opacity: loadingOptimizeVariant ? 0.05 : 1 } },
            React.createElement(validate_step_1.default, { skipSteps: skipStepsMemoized }),
            !hideLeft && (React.createElement("div", { className: 'cell show-for-large large-6 bg-pampas grid-y align-middle align-center' },
                React.createElement(react_router_dom_1.Route, { render: function (props) { return React.createElement(left_1.default, __assign({}, props, { images: steps.map(function (step) { return step.leftImage; }) })); } }))),
            React.createElement("div", { className: 'cell auto grid-y bg-white' },
                !existingBundle && (React.createElement("div", { className: 'cell shrink' },
                    React.createElement(react_router_dom_1.Route, { render: function (props) { return React.createElement(progress_1.default, __assign({}, props, { skipSteps: skipStepsMemoized, titles: steps.map(function (step) { return [step.navTitleTiny, step.navTitle]; }) })); } }))),
                React.createElement(react_router_dom_1.Switch, null,
                    React.createElement(react_router_dom_1.Redirect, { exact: true, from: '/', to: directStep || baseRoutes[0] }),
                    React.createElement(react_router_dom_1.Route, { exact: true, path: baseRoutes[0], render: function (props) { return (React.createElement(select_size_1.default, __assign({}, props, { numChoicesPerSize: numChoicesPerSize, enableTrustPilotAB: enableTrustPilotAB, enableTrainingPants: enableTrainingPants, settings: steps[0] }))); } }),
                    React.createElement(react_router_dom_1.Route, { path: baseRoutes[1], render: function (props) { return (React.createElement(select_prints_1.default, __assign({}, props, { key: "select-prints-".concat(currentSubStepIdx), enableNighttimeDiapers: enableNighttimeDiapers, possibleChoices: possibleChoices, possibleNighttimeChoices: possibleNighttimeChoices, settings: steps[1] }))); } }),
                    React.createElement(react_router_dom_1.Route, { exact: true, path: baseRoutes[2], render: function (props) { return React.createElement(select_add_ons_1.default, __assign({}, props, { addOns: addOns, numAddOns: numAddOns, settings: steps[2] })); } }),
                    React.createElement(react_router_dom_1.Route, { exact: true, path: baseRoutes[3], render: function (props) { return React.createElement(select_discount_add_ons_1.default, __assign({}, props, { discountAddOns: discountAddOns, numDiscountAddOns: numDiscountAddOns, settings: steps[3] })); } }),
                    React.createElement(react_router_dom_1.Route, { exact: true, path: baseRoutes[4], render: function (props) { return (React.createElement(select_frequency_1.default, __assign({}, props, { shippingIntervalFrequencies: shippingIntervalFrequencies, shippingIntervalUnitType: shippingIntervalUnitType, settings: steps[4] }))); } }),
                    React.createElement(react_router_dom_1.Route, { exact: true, path: baseRoutes[5], render: function (props) { return (React.createElement(confirm_1.default, __assign({}, props, { autoAddOns: autoAddOns, enableTrustPilotAB: enableTrustPilotAB, possibleNighttimeChoices: possibleNighttimeChoices, shippingIntervalUnitType: shippingIntervalUnitType, shippingIntervalFrequencies: shippingIntervalFrequencies, settings: steps[5] }))); } }),
                    React.createElement(react_router_dom_1.Redirect, { to: baseRoutes[0] }))),
            React.createElement(scoll_on_nav_change_1.default, null))));
};
exports.default = (function (props) { return (React.createElement(react_router_dom_1.HashRouter, { basename: props.basename },
    React.createElement(App, __assign({}, props)))); });
